import { RootState } from 'store';

const ServiceBranchesLookupState = (state: RootState) => state.lookups.serviceBranches;

export const selectServiceBranches = (state: RootState) => ServiceBranchesLookupState(state).rows;
